//#region Imports
import { useEffect, useState } from 'react';
import {
  Autocomplete,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import moment from 'moment';

import customAxios from '../../../utils/customAxios';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
//#endregion

const HEADERS = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  },
};

const ModalSUpdate = ({ siteId, show, onHide, getSites, selectedClients }) => {
  const [name, setName] = useState('');
  const [client, setClient] = useState('');
  const [addressStreet, setAddressStreet] = useState('');
  const [addressNumber, setAddressNumber] = useState('');
  const [addressColony, setAddressColony] = useState('');
  const [addressCityId, setAddressCityId] = useState('');
  const [addressStateId, setAddressStateId] = useState('');
  const [addressCountryId, setAddressCountryId] = useState('');
  const [addressPC, setAddressPC] = useState('');
  const [cr, setCr] = useState('');
  const [isPriority, setIsPriority] = useState(null);
  // const [clientTi, setClientTi] = useState('');
  // const [extraClientTi, setExtraClientTi] = useState('');
  const [clientsTi, setClientsTi] = useState([]);
  const [selectedClientsTi, setSelectedClientsTi] = useState([]);
  const [notes, setNotes] = useState('');
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [coordanates, setCoordanates] = useState({
    latitude: null,
    longitude: null,
  });
  const [entryDate, setEntryDate] = useState(null);
  const [equalDate, setEqualDate] = useState(null);
  const [prevDate, setPrevDate] = useState(null);
  const [kms, setKms] = useState('');
  const [km1, setKm1] = useState('');
  const [kmLevelHrs, setKmLevelHrs] = useState('');
  const [kmLevel, setKmLevel] = useState('');

  const { notesString, siteStreetNameString, siteAddressNumString } =
    useTranslationHook();

  useEffect(() => {
    if (show) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const fetchData = async () => {
    setIsFetching(true);

    try {
      const [countriesData, clientTiData, selectedClientsTiData, siteData] =
        await Promise.all([
          fetchCountries(),
          fetchClientTis(),
          fetchClientTiBySiteId(),
          fetchSite(),
        ]);

      setCountries(countriesData);
      setClientsTi(clientTiData);
      setSelectedClientsTi(selectedClientsTiData);
      setName(siteData.site_name);
      setClient(siteData.business_name);
      setCr(siteData.cr);
      setAddressCountryId(siteData.country_id);
      setAddressStateId(siteData.state_id);
      setAddressCityId(siteData.city_id);
      setAddressColony(siteData.address_colony);
      setAddressStreet(siteData.address_street);
      setIsPriority(siteData.is_priority);
      setAddressNumber(siteData.address_number);
      setAddressPC(siteData.address_postal_code);
      setNotes(siteData.notes);
      setCoordanates({
        latitude: siteData.latitude,
        longitude: siteData.longitude,
      });
      setEntryDate(siteData.entry_date ? moment(siteData.entry_date) : null);
      setEqualDate(siteData.equal_date ? moment(siteData.equal_date) : null);
      setPrevDate(siteData.prev_date ? moment(siteData.prev_date) : null);
      setKms(siteData.kms || '');
      setKm1(siteData.km1 || '');
      setKmLevel(siteData.kmnivel || '');
      setKmLevelHrs(siteData.kmnivel_hrs || '');
      setInitialData({ ...siteData, selectedClientsTi: selectedClientsTiData });
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error al obtener datos',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const fetchClientTis = async () => {
    const endpoint = `${GlobalVariables.getURL()}client-ti/listAllClientTi`;
    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      if (response.status === 204) {
        return [];
      }
      return response.data.data;
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClientTiBySiteId = async () => {
    const endpoint = `${GlobalVariables.getURL()}client-ti/listClientTiBySiteID/${siteId}`;
    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      if (response.status === 204) {
        return [];
      }
      return response.data.data;
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCountries = async () => {
    const endpoint = `${GlobalVariables.getURL()}autofillCountryDetails`;
    const response = await customAxios.get(endpoint, HEADERS);

    if (response.status === 204) {
      return [];
    }

    return response.data.countries;
  };

  const fetchSite = async () => {
    const endpoint = `${GlobalVariables.getURL()}listSiteByID/${siteId}`;
    const response = await customAxios.get(endpoint, HEADERS);

    if (response.status === 204) {
      return {};
    }

    return response.data;
  };

  useEffect(() => {
    if (addressCountryId) {
      fetchStates();
    } else {
      setAddressStateId(null);
      setStates([]);
      setAddressCityId(null);
      setCities([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressCountryId]);

  const fetchStates = async () => {
    try {
      const endpoint = `${GlobalVariables.getURL()}statesByCountry/${addressCountryId}`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204) {
        setStates([]);
        return;
      }

      setStates(response.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  useEffect(() => {
    if (addressStateId) {
      fetchCities();
    } else {
      setAddressCityId(null);
      setCities([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressStateId]);

  const fetchCities = async () => {
    try {
      const endpoint = `${GlobalVariables.getURL()}cititesByState/${addressStateId}`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204) {
        setCities([]);
        return;
      }

      setCities(response.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  const resetFormFields = () => {
    setClient('');
    setName('');
    setAddressStreet('');
    setAddressNumber('');
    setAddressColony('');
    setAddressCityId(null);
    setCities([]);
    setAddressStateId(null);
    setStates([]);
    setAddressCountryId(null);
    setCountries([]);
    setAddressPC('');
    setNotes('');
    setCr('');
    setIsPriority(null);
    // setClientTi('');
    // setExtraClientTi('');
    setCoordanates({
      latitude: null,
      longitude: null,
    });
    setEntryDate(null);
    setEqualDate(null);
    setPrevDate(null);
    setKms('');
    setKm1('');
    setKmLevel('');
    setKmLevelHrs('');
    setSelectedClientsTi([]);
    setInitialData(null);
  };

  const hide = () => {
    onHide();
    getToast({
      status: 'success',
      title: 'Sucursal actualizada exitosamente en la base de datos.',
    });
    let endpoint = `${GlobalVariables.getURL()}listClientSites`;
    if (selectedClients.length > 0) {
      endpoint += `?id=${selectedClients}`;
    }
    getSites(endpoint);
  };

  const updateSite = async (event) => {
    event.preventDefault();

    if (!initialData) return;

    const formatDate = (d) => (d ? moment.utc(d).format('YYYY-MM-DD') : null);

    const changedFields = {};

    if (name !== initialData.site_name) changedFields.site_name = name;
    if (addressStreet !== initialData.address_street)
      changedFields.address_street = addressStreet;
    if (addressNumber !== initialData.address_number)
      changedFields.address_number = addressNumber;
    if (addressColony !== initialData.address_colony)
      changedFields.address_colony = addressColony;
    if (addressCityId !== initialData.city_id)
      changedFields.address_city_id = addressCityId;
    if (addressStateId !== initialData.state_id)
      changedFields.address_state_id = addressStateId;
    if (addressCountryId !== initialData.country_id)
      changedFields.address_country_id = addressCountryId;
    if (addressPC !== initialData.address_postal_code)
      changedFields.address_postal_code = addressPC;
    if (notes !== initialData.notes) changedFields.notes = notes;
    if (cr !== initialData.cr) changedFields.cr = cr;
    if (String(isPriority) !== String(initialData.is_priority))
      changedFields.is_priority = isPriority;
    if (initialData.assigned_to !== null) changedFields.assigned_to = null;

    const currentLat =
      coordanates.latitude === '' || coordanates.latitude == null
        ? null
        : Number(coordanates.latitude);
    const currentLng =
      coordanates.longitude === '' || coordanates.longitude == null
        ? null
        : Number(coordanates.longitude);
    if (currentLat !== initialData.latitude)
      changedFields.latitude = currentLat;
    if (currentLng !== initialData.longitude)
      changedFields.longitude = currentLng;

    const currentEntryDate = formatDate(entryDate);
    const currentEqualDate = formatDate(equalDate);
    const currentPrevDate = formatDate(prevDate);
    const initialEntryDate = formatDate(
      initialData.entry_date ? moment(initialData.entry_date) : null,
    );
    const initialEqualDate = formatDate(
      initialData.equal_date ? moment(initialData.equal_date) : null,
    );
    const initialPrevDate = formatDate(
      initialData.prev_date ? moment(initialData.prev_date) : null,
    );
    if (currentEntryDate !== initialEntryDate)
      changedFields.entry_date = currentEntryDate;
    if (currentEqualDate !== initialEqualDate)
      changedFields.equal_date = currentEqualDate;
    if (currentPrevDate !== initialPrevDate)
      changedFields.prev_date = currentPrevDate;

    if ((kms || null) !== (initialData.kms || null))
      changedFields.kms = kms || null;
    if ((km1 || null) !== (initialData.km1 || null))
      changedFields.km1 = km1 || null;
    if ((kmLevel || null) !== (initialData.kmnivel || null))
      changedFields.kmnivel = kmLevel || null;
    if ((kmLevelHrs || null) !== (initialData.kmnivel_hrs || null))
      changedFields.kmnivel_hrs = kmLevelHrs || null;

    const initialClientTiIds = (initialData.selectedClientsTi || [])
      .map((c) => c.id)
      .sort((a, b) => a - b);
    const currentClientTiIds = selectedClientsTi
      .map((c) => c.id)
      .sort((a, b) => a - b);
    if (
      JSON.stringify(initialClientTiIds) !== JSON.stringify(currentClientTiIds)
    ) {
      changedFields.client_ti = currentClientTiIds;
    }

    if (Object.keys(changedFields).length === 0) {
      getToast({ status: 'info', title: 'No se realizaron cambios.' });
      return;
    }

    changedFields.updated_reason = 'Site updated from web interface';

    setIsLoading(true);

    try {
      const endpoint = `${GlobalVariables.getURL()}updateSite/${siteId}`;
      const response = await customAxios.patch(
        endpoint,
        changedFields,
        HEADERS,
      );

      if (response.status === 200) hide();
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title:
          error.response?.data?.message ||
          'Error al actualizar sucursal. Vuelve a intentarlo.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    onHide();
    resetFormFields();
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale={moment.locale()}
    >
      <Dialog open={show} maxWidth="xl" fullWidth onClose={handleClose}>
        <DialogTitle>
          <Typography className="inventory-movmodal-title">
            Editar sucursal
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 20,
            top: 20,
            width: 40,
            height: 40,
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
        <DialogContent dividers>
          <form id="update-site-form" onSubmit={updateSite}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    fullWidth
                    label="Plaza"
                    placeholder="Plaza..."
                    type="text"
                    value={client}
                    InputLabelProps={{ shrink: true }}
                    disabled
                  />
                )}
              </Grid>

              <Grid item xs={12}>
                <Divider>Información de la sucursal</Divider>
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    fullWidth
                    label="Nombre de la sucursal"
                    placeholder="Nombre de la sucursal..."
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    fullWidth
                    label="CR"
                    placeholder="CR..."
                    type="text"
                    value={cr}
                    onChange={(e) => setCr(e.target.value)}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    disabled={isLoading}
                    options={countries}
                    value={
                      countries.find((c) => c.id === addressCountryId) || null
                    }
                    getOptionLabel={(country) => country.co_name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) =>
                      setAddressCountryId(newValue ? newValue.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        {...params}
                        label="País"
                        placeholder="País..."
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    disabled={isLoading}
                    options={states}
                    value={states.find((s) => s.id === addressStateId) || null}
                    getOptionLabel={(s) => s.st_name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) =>
                      setAddressStateId(newValue ? newValue.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        {...params}
                        label="Estado"
                        placeholder="Estado..."
                      />
                    )}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    disabled={isLoading}
                    options={cities}
                    value={cities.find((c) => c.id === addressCityId) || null}
                    getOptionLabel={(cities) => cities.ci_name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) =>
                      setAddressCityId(newValue ? newValue.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        {...params}
                        label="Municipio / Delegación"
                        placeholder="Municipio / Delegación..."
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="Colonia"
                    placeholder="Colonia..."
                    type="text"
                    value={addressColony}
                    onChange={(e) => setAddressColony(e.target.value)}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label={siteStreetNameString}
                    placeholder={`${siteStreetNameString}...`}
                    type="text"
                    value={addressStreet}
                    onChange={(e) => setAddressStreet(e.target.value)}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label={siteAddressNumString}
                    placeholder={`${siteAddressNumString}...`}
                    value={addressNumber}
                    onChange={(e) => setAddressNumber(e.target.value)}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="Código postal"
                    placeholder="Código postal..."
                    type="number"
                    value={addressPC}
                    onChange={(e) => setAddressPC(e.target.value)}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    multiple
                    disabled={isLoading}
                    options={clientsTi}
                    value={selectedClientsTi}
                    getOptionLabel={(client) =>
                      client.full_name || client.name || ''
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) => setSelectedClientsTi(newValue)}
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        {...params}
                        label="Contacto Sucursal"
                        placeholder="Contacto Sucursal..."
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label">
                    ¿Es sucursal prioritaria?
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={isPriority}
                    onChange={(e) => setIsPriority(e.target.value)}
                    row
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Sí"
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Divider>Fechas y datos adicionales</Divider>
              </Grid>

              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <DatePicker
                    sx={{ width: '100%' }}
                    label="Fecha ingreso"
                    value={entryDate}
                    onChange={(newDate) => setEntryDate(newDate)}
                    disabled={isLoading}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <DatePicker
                    sx={{ width: '100%' }}
                    label="Fecha de igual a"
                    value={equalDate}
                    onChange={(newDate) => setEqualDate(newDate)}
                    disabled={isLoading}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <DatePicker
                    sx={{ width: '100%' }}
                    label="Fecha anterior"
                    value={prevDate}
                    onChange={(newDate) => setPrevDate(newDate)}
                    disabled={isLoading}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={3}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="KMS"
                    placeholder="KMS..."
                    type="number"
                    value={kms}
                    onChange={(e) => {
                      const value = e.target.value;
                      setKms(value === '' ? '' : Number(value));
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={3}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="KM1"
                    placeholder="KM1..."
                    type="number"
                    value={km1}
                    onChange={(e) => {
                      const value = e.target.value;
                      setKm1(value === '' ? '' : Number(value));
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={3}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="KM Nivel"
                    placeholder="KM Nivel..."
                    type="number"
                    value={kmLevel}
                    onChange={(e) => {
                      const value = e.target.value;
                      setKmLevel(value === '' ? '' : Number(value));
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={3}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="HRS KMNIVEL"
                    placeholder="HRS KMNIVEL..."
                    type="number"
                    value={kmLevelHrs}
                    onChange={(e) => {
                      const value = e.target.value;
                      setKmLevelHrs(value === '' ? '' : Number(value));
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="Latitud"
                    placeholder="Coordenadas de latitud"
                    type="number"
                    value={coordanates.latitude}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCoordanates({
                        ...coordanates,
                        latitude: value === '' ? '' : Number(value),
                      });
                    }}
                    inputProps={{ step: 'any' }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="Longitud"
                    placeholder="Coordenadas de longitud"
                    type="number"
                    value={coordanates.longitude}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCoordanates({
                        ...coordanates,
                        longitude: value === '' ? '' : Number(value),
                      });
                    }}
                    inputProps={{ step: 'any' }}
                  />
                )}
              </Grid>

              <Grid item xs={12}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label={notesString}
                    placeholder={`${notesString}...`}
                    type="text"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                )}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            form="update-site-form"
            type="submit"
            disabled={isLoading || isFetching}
          >
            {isLoading ? (
              <CircularProgress size="2rem" />
            ) : (
              <Typography>Guardar</Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default ModalSUpdate;
